<app-modal (overlayClick)="onClose()" class="md:!w-[48rem]">
  <div class="app-modal__header relative">
    <div class="w-full p-5 bg-[#E7E7FF] rounded-xl">
      <div class="flex max-sm:flex-col items-start justify-start gap-3">
        <div
          class="size-16 bg-ppdms-primary rounded-full flex items-center justify-center"
        >
          <app-iconify-icon
            icon="lucide:user-star"
            class="text-white text-4xl"
          ></app-iconify-icon>
        </div>
        <div>
          <h3 class="app-modal__header__title">
            {{ currentUser?.name || "N/A" }}
          </h3>
          <p class="app-modal__header__sub-title mb-2">
            {{ currentUser?.email || "N/A" }}
          </p>
          <span class="app-pill bg-ppdms-primary text-white">
            {{ currentUser?.accountType || "N/A" }}
          </span>
        </div>
      </div>
    </div>
    <app-iconify-icon
      (click)="onClose()"
      icon="basil:cancel-solid"
      class="absolute -right-2 text-5xl text-red-600 cursor-pointer"
    ></app-iconify-icon>
  </div>

  <div class="space-y-4">
    <div
      class="text-ppdms-text-1 flex max-sm:flex-col max-sm:items-start items-center justify-between max-sm:gap-2 gap-4"
    >
      <p>Company Address</p>
      <p class="font-medium">{{ currentUser?.companyAddress || "N/A" }}</p>
    </div>
  </div>

  @if (requiresAction) {
    <div class="mt-8 py-4 px-6 max-sm:px-4 rounded-xl bg-[#ffe3e3]">
      <div class="flex max-sm:flex-col items-start justify-start gap-3">
        <app-iconify-icon
          icon="charm:circle-cross"
          class="text-5xl text-[#F80404]"
        ></app-iconify-icon>
        <div>
          <h3 class="text-[#f61818] font-semibold">
            {{ requiredActionMessage }}
          </h3>
          <p class="text-sm text-[#F80404]">Your account is in bad standing</p>
          <p class="mt-3 text-[#595A69] text-sm font-light">
            Last login:
            {{ (currentUser?.lastLoginTime | date: "long") || "N/A" }}
          </p>
        </div>
      </div>
    </div>
  } @else {
    <div class="mt-8 py-4 px-6 rounded-xl bg-[#DDFFDE]">
      <div class="flex max-sm:flex-col items-start justify-start gap-4">
        <app-iconify-icon
          icon="oui:check-in-circle-empty"
          class="text-5xl text-[#35CC3D]"
        ></app-iconify-icon>
        <div>
          <h3 class="text-[#35CC3D] font-semibold">Account Active</h3>
          <p class="text-sm text-[#0C6411]">Your account is in good standing</p>
          <p class="mt-3 text-[#595A69] text-sm font-light">
            Last login:
            {{ (currentUser?.lastLoginTime | date: "long") || "N/A" }}
          </p>
        </div>
      </div>
    </div>
  }

  <div class="mt-8 py-4 px-6 rounded-xl border border-[#F1F1FF]">
    <div class="flex max-sm:flex-col items-center justify-between gap-3">
      <div class="flex max-sm:flex-col items-start justify-start gap-4">
        <div
          class="size-fit bg-[#F1F1FF] p-2 rounded-2xl flex items-center justify-center"
        >
          <app-iconify-icon
            icon="material-symbols-light:shield-lock-outline"
            class="text-4xl text-ppdms-primary"
          ></app-iconify-icon>
        </div>
        <div>
          <h3 class="text-ppdms-black font-semibold">
            Two-factor authentication
          </h3>
          <p class="text-sm text-ppdms-text-1">
            Protect sign in with an authenticator app.
          </p>
        </div>
      </div>

      <div
        class="w-12 min-w-12 h-6 max-sm:self-start relative bg-ppdms-gray rounded-full has-[:checked]:bg-ppdms-primary duration-300"
      >
        <input
          type="checkbox"
          class="size-full absolute inset-0 opacity-0 z-50 cursor-pointer peer"
          [checked]="isActive()"
          (change)="toggleTotp()"
          [disabled]="mfaPhase === 'PROCESSING'"
        />
        <div
          class="size-4 relative top-1/2 -translate-y-1/2 translate-x-1 bg-white rounded-full peer-checked:translate-x-7 duration-300"
        ></div>
      </div>
    </div>

    <!-- Indicator -->
    <div
      class="mt-4 size-fit py-2 px-4 rounded-full flex items-center justify-center gap-3"
      [ngClass]="{
        'bg-gray-100': !isActive(),
        'bg-[#F1F1FF]': isActive(),
      }"
    >
      <div
        class="size-3 rounded-full"
        [ngClass]="{
          'bg-gray-300': !isActive(),
          'bg-ppdms-primary': isActive(),
        }"
      ></div>
      <p
        class="text-sm font-semibold"
        [ngClass]="{
          'text-ppdms-text-1': !isActive(),
          'text-ppdms-primary': isActive(),
        }"
      >
        {{
          (mfaPhase === "ENABLED" && "Enabled") ||
            (mfaPhase === "DISABLED" && "Disabled") ||
            (mfaPhase === "PROCESSING" && "Processing...") ||
            (mfaPhase === "SETUP_PENDING" && "Setup Pending") ||
            ""
        }}
      </p>
    </div>

    @if (mfaPhase === "SETUP_PENDING") {
      <div>
        <hr class="mt-4 border border-gray-200" />

        <div
          class="mt-4 flex max-sm:flex-col items-start justify-between gap-3"
        >
          <div
            class="h-fit md:w-72 p-4 bg-gradient-to-br from-ppdms-primary to-ppdms-secondary shadow-2xl rounded-xl"
          >
            <div class="relative min-h-44 p-5 bg-white rounded-xl">
              <div
                class="absolute top-2 left-2 size-6 border-4 border-b-0 border-r-0 border-ppdms-secondary rounded-tl-xl rounded-br-xl"
              ></div>
              <div
                class="absolute bottom-2 right-2 size-6 border-4 border-t-0 border-l-0 border-ppdms-secondary rounded-tl-xl rounded-br-xl"
              ></div>
              <div class="size-full" #qrCode></div>
            </div>
            <p
              class="w-11/12 mx-auto mt-4 text-sm text-white text-center font-semibold"
            >
              Open Google Authenticator and scan this code.
            </p>
          </div>

          <div class="max-w-full max-sm:mt-2 max-sm:grow">
            <p class="font-bold">Scan QR code</p>
            <p class="mt-1 text-sm text-ppdms-text-1">
              Use Google Authenticator, then enter the generated 6-digit code.
            </p>

            <div
              class="mt-3 py-2 ps-3 pe-2 border border-gray-200 bg-gray-50 rounded-xl flex items-center justify-between gap-2"
            >
              <p [style]="{ 'word-break': 'break-all' }">
                {{ manualEntryKey || "-" }}
              </p>
              <div
                (click)="copyManualEntryKey()"
                class="py-2 px-3 bg-[#F1F1FF] rounded-xl text-sm text-ppdms-primary font-semibold cursor-pointer"
              >
                {{ isCopied ? "Copied" : "Copy" }}
              </div>
            </div>

            <div class="mt-5">
              <p class="text-sm text-ppdms-black font-semibold">
                Authenticator Code
              </p>
              <input
                type="text"
                placeholder="000000"
                class="w-full mt-2 p-2 border border-gray-300 text-lg rounded-xl tracking-[1rem]"
                (input)="onAuthCodeInput($event)"
                (keydown)="onAuthCodeKeyDown($event)"
              />

              <div
                class="mt-4 flex max-sm:flex-col items-center justify-start gap-3"
              >
                <button
                  (click)="confirm2faSetup()"
                  [disabled]="!isCodeInputValid"
                  class="app-button app-button-primary py-2 px-4 max-sm:w-full"
                >
                  Verify and enable
                </button>
                <button
                  (click)="toggleTotp()"
                  class="app-button border border-gray-400 py-2 px-4 max-sm:w-full"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</app-modal>
